function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import DeleteConfirmationModal from './DeleteConfirmationModal';

/**
 * To add a new type, create its modal component and add it here.
 */
const CONFIRMATION_MODALS = {
  delete: DeleteConfirmationModal
};

/**
 * Renders the modal for `request.type`. `request` is what was passed to confirm() - see useConfirmationModal.
 * Modal size defaults to 'lg'; pass `size` to confirm() to override it.
 */
export default function ConfirmationModal(_ref) {
  let {
    request,
    onCancel
  } = _ref;
  if (!request) return null;
  const {
    type,
    ...modalProps
  } = request;
  const TypeModal = CONFIRMATION_MODALS[type];
  if (!TypeModal) {
    throw new Error(`Unsupported confirmation modal type: ${type}.`);
  }
  return /*#__PURE__*/React.createElement(TypeModal, _extends({
    size: "lg"
  }, modalProps, {
    onCancel: onCancel
  }));
}